<script lang="ts">
	import { login, base_url, redirect_uri, client_id } from "./tastummy_login";
	import { user_token } from "./jwt_store";
	import Loading from "./general/Loading.svelte";

	let username: string;
	let password: string;
	let loading: boolean = false;
	let error_message: string = "";

	// wait for login to be processed
	setTimeout(() => {
		// save path to redirect to after login
		localStorage.setItem("redirect", window.location.pathname);
		if ($user_token == "") {
			// forward to login page
			let url = `https://tastummy.auth.us-west-2.amazoncognito.com/login?response_type=code&client_id=${client_id}&redirect_uri=${redirect_uri}`;
			window.location.href = url;
		}
	}, 1000);

	async function do_login() {
		loading = true;
		login(username, password)
			.then((req) => {
				$user_token = req.data.access;
			})
			.catch((e) => {
				console.log("failed to login", e.response.status);
				error_message = "invalid username or password provided";
			})
			.finally(() => {
				loading = false;
			});
		username = "";
		password = "";
		error_message = "";
	}
	function handle_keydown(event: KeyboardEvent) {
		if (event.key == "Enter") {
			do_login();
		}
	}
</script>

{#if error_message != ""}
	<p>{error_message}</p>
{/if}

{#if loading}
	<Loading />
{:else}
	<div class="login-form">
		<input placeholder="Username" bind:value={username} />
		<input
			placeholder="Password"
			type="password"
			bind:value={password}
			on:keypress={handle_keydown}
		/>
		<button on:click={do_login}>Login</button>
		<a class="button" href={base_url + "/recipe/signup"}>Create Account</a>
	</div>
{/if}

<style>
	input {
		margin: 0.5rem;
		width: auto;
		grid-column: 1 / -1;
	}
	button {
		margin: 1rem;
	}
	a {
		margin: 1rem;
	}
	p {
		color: red;
		font-size: 2em;
	}
	.login-form {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
	}
</style>
